<p class="modal-title">Appearances: {{ itemName() }}</p>
<div class="body">
  <div class="appearances-table">
    <div class="appearances-header">
      <span class="col-user">User</span>
      <span class="col-item">Item</span>
      <span class="col-game">Game</span>
      <span class="col-date">Date</span>
    </div>
    @if (entriesResource.isLoading()) {
      <div class="appearances-row empty">Loading appearances…</div>
    } @else if (entriesResource.error()) {
      <div class="appearances-row empty">{{ errorText() }}</div>
    } @else {
    @for (entry of entries(); track $index) {
      <div class="appearances-row">
        <span class="col-user">
          @if (entry.user.avatar) {
            <img
              class="avatar"
              [src]="entry.user.avatar"
              [appTooltip]="entry.user.name"
              alt=""
            />
          }
          <span class="user-name">{{ entry.user.name }}</span>
          <span class="user-level">({{ entry.user.level }})</span>
        </span>
        <span class="col-item">
          @if (entry.item_image) {
            <img class="item-image" [src]="entry.item_image" [appTooltip]="entry.item_name" alt="" />
          }
          <span class="item-price">{{ entry.item_price | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
        </span>
        <span class="col-game">
          <span class="game-type">{{ entry.game_type }}</span>
          <span class="game-id">{{ entry.game_id }}</span>
        </span>
        <span class="col-date">
          {{ entry.date * 1000 | date : 'yyyy.MM.dd HH:mm' }}
        </span>
      </div>
    }
    @if (entries().length === 0) {
      <div class="appearances-row empty">No appearances recorded</div>
    }
    }
  </div>
</div>
